<template>
  <v-dialog v-model="mostradoModal" max-width="1200" scrollable>
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Detalles de Montos</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th class="text-right">Monto</th>
                    <th class="text-right">Descuento</th>
                    <th class="text-right">Pagado</th>
                    <th class="text-right">Regularizado</th>
                    <th class="text-right">Compensado</th>
                    <th class="text-right">Liquidado</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>Matrícula</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.montoMatricula)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.descuentoMatricula)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.pagoMatricula)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.regularizadoMatricula)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.compensacionColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.liquidadoMatricula)) }}</td>
                  </tr>

                  <tr>
                    <td>Colegiatura</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.montoColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.descuentoColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.pagoColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.regularizadoColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.compensacionColegiatura)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.liquidadoColegiatura)) }}</td>
                  </tr>

                  <tr>
                    <td>Certificación</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.montoCertificacion)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.descuentoCertificacion)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.pagoCertificacion)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.regularizadoCertificacion)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.compensacionCertificacion)) }}</td>
                    <td class="text-right">{{ formatearValorAMoneda(Number(montos.liquidadoCertificacion)) }}</td>
                  </tr>

                  <tr>
                    <td class="font-weight-bold">TOTAL</td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.montoMatricula) || 0) +
                            (Number(montos?.montoColegiatura) || 0) +
                            (Number(montos?.montoCertificacion) || 0),
                        )
                      }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.descuentoMatricula) || 0) +
                            (Number(montos?.descuentoColegiatura) || 0) +
                            (Number(montos?.descuentoCertificacion) || 0),
                        )
                      }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.pagoMatricula) || 0) +
                            (Number(montos?.pagoColegiatura) || 0) +
                            (Number(montos?.pagoCertificacion) || 0),
                        )
                      }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.regularizadoMatricula) || 0) +
                            (Number(montos?.regularizadoColegiatura) || 0) +
                            (Number(montos?.regularizadoCertificacion) || 0),
                        )
                      }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.compensacionMatricula) || 0) +
                            (Number(montos?.compensacionColegiatura) || 0) +
                            (Number(montos?.compensacionCertificacion) || 0),
                        )
                      }}
                    </td>
                    <td class="text-right font-weight-bold">
                      {{
                        formatearValorAMoneda(
                          (Number(montos?.liquidadoMatricula) || 0) +
                            (Number(montos?.liquidadoColegiatura) || 0) +
                            (Number(montos?.liquidadoCertificacion) || 0),
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click="mostradoModal = false"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatearValorAMoneda } from '../utils/funciones';
export default {
  name: 'ModalDetallesMontos',
  props: {
    montos: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mostradoModal: false,
    };
  },
  methods: {
    abrir() {
      this.mostradoModal = true;
    },
    formatearValorAMoneda(valor) {
      return formatearValorAMoneda(valor);
    },
  },
};
</script>